<script setup>
import CardLabel from '@/Components/Card/CardLabel.vue';
import Card from '@/Components/Card/Card.vue';
import AuthResultsResult from '@/Pages/HeaderAnalysis/Partials/AuthResultsResult.vue';
import PropertyListItem from '@/Pages/HeaderAnalysis/Partials/PropertyListItem.vue';

defineProps({
  receivedSpf: Array
});
</script>

<template>
  <div id="received-spf">
    <CardLabel
      :label="$t('header_analysis.partials.received_spf.received_spf')"
    />
    <Card v-if="0 === receivedSpf.length">
      <div>{{ $t('header_analysis.partials.received_spf.no_results') }}</div>
    </Card>
    <div v-else class="flex flex-col gap-2">
      <Card v-for="(spf, idx) in receivedSpf" :key="idx">
        <div class="flex w-1/2">
          <div class="w-1/3">
            {{ $t('header_analysis.partials.received_spf.result') }}
          </div>
          <AuthResultsResult :result="spf.result" />
        </div>

        <div class="mt-6 flex w-1/2 flex-col">
          <div class="font-bold">
            {{ $t('header_analysis.partials.received_spf.properties') }}
          </div>
          <PropertyListItem
            v-for="(val, prop) in spf.properties"
            :key="prop"
            :title-class="['w-1/3']"
            :title="prop"
            :value="val"
          />
        </div>

        <div class="mt-6 flex flex-col">
          <div class="font-bold">
            {{ $t('header_analysis.partials.received_spf.comments') }}
          </div>
          <div v-for="(c, i) in spf.comments" :key="i" class="break-words">
            {{ c }}
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>
